import Hangman from "./Hangman"
import './App.css';

function App() {
  return (
    <div className="App">
      <Hangman/>
    </div>
  );
}

export default App;
